import styled from "styled-components";

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.text};
  font-size: ${({ theme }) => theme.fontSizes.large};
  font-weight: ${({ theme }) => theme.fontWeights.xxbold};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const Description = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.xl};
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${({ theme }) => theme.colors.text};
`;

export const EmailSpan = styled.span`
  color: ${({ theme }) => theme.colors.text};
  font-weight: ${({ theme }) => theme.fontWeights.xxbold};
  font-size: ${({ theme }) => theme.fontSizes.large};
`;

export const OtpInputContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.xl};
  max-width: 304px;
`;

export const ResendContainer = styled.div`
  width: 100%;
  text-align: left;
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

export const ResendText = styled.span`
  font-size: 1rem;
  font-weight: 400;
  margin-bottom:${({ theme }) => theme.spacing.xs};
`;

export const ResendLink = styled.span<{ $isActive: boolean }>`
  font-size: 1rem;
  font-weight: 400;
    text-decoration: ${({ $isActive }) => ($isActive ? "underline" : "none")};

  color: #34A853;
  cursor: pointer;
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0.8)};
  pointer-events: ${({ $isActive }) => ($isActive ? "auto" : "none")};
`;

export const FullScreenContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  background-color: white;
  overflow: hidden;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  overflow: hidden;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
`;
